import { createActions, createReducer } from 'reduxsauce'

import ReceitaArrecadadaService from '../../servicos/ReceitaArrecadadaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaReceitaArrecadadaInicio: [],
    buscaReceitaArrecadadaSucesso: ['receitaArrecadada'],
    buscaReceitaArrecadadaErro: ['erro'],
    setSelecionadoReceitaArrecadadaSucesso: ['selecionado'],
    setReceitaArrecadadaEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaReceitaArrecadada = filtro => {
    return dispatch => {
        dispatch(Creators.buscaReceitaArrecadadaInicio())
        let serv = new ReceitaArrecadadaService()
        let data = {
            exercicio: filtro.exercicio.value,
            mes: filtro.mes && filtro.mes.value < 10 ? '0' + filtro.mes.value : filtro.mes.value,
            administracao: filtro.administracoes ? filtro.administracoes.map(e => e.value).join() : '',
            recurso: filtro.recursos ? filtro.recursos.map(e => e.value).join() : '',
            destinacao: filtro.destinacoes ? filtro.destinacoes.map(e => e.value).join() : '',
            tipoRecurso: filtro.tipoRecursos ? filtro.tipoRecursos.map(e => e.value).join() : '',
            sequencia: filtro.sequencia ? filtro.sequencia.sequencia : null,
            grau: filtro.grau ? filtro.grau.value : null,
        }

        return serv
            .consultar(data)
            .then(response => dispatch(Creators.buscaReceitaArrecadadaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaReceitaArrecadadaErro(error)))
    }
}

const buscaReceitaArrecadadaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaReceitaArrecadadaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaReceitaArrecadadaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.receitaArrecadada.resultado, dataSincronizacaoDados: action.receitaArrecadada.dataSincronizacaoDados, carregando: false }
}

const setSelecionadoReceitaArrecadadaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

const setReceitaArrecadadaEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RECEITA_ARRECADADA_INICIO]: buscaReceitaArrecadadaInicio,
    [Types.BUSCA_RECEITA_ARRECADADA_ERRO]: buscaReceitaArrecadadaErro,
    [Types.BUSCA_RECEITA_ARRECADADA_SUCESSO]: buscaReceitaArrecadadaSucesso,
    [Types.SET_SELECIONADO_RECEITA_ARRECADADA_SUCESSO]: setSelecionadoReceitaArrecadadaSucesso,
    [Types.SET_RECEITA_ARRECADADA_ESTADO_DT]: setReceitaArrecadadaEstadoDT,
})
